export const IconClose = () => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="1.89555"
      y1="0.919884"
      x2="26.1018"
      y2="25.1262"
      stroke="currentColor"
    />
    <line
      x1="1.18844"
      y1="25.1269"
      x2="25.3947"
      y2="0.920641"
      stroke="currentColor"
    />
  </svg>
)
